module.exports = __webpack_public_path__ + "static/media/0.e7b78028.png";